import { REQUEST_DEPARTMENT_LIST, REQUEST_DEPARTMENT_LIST_ERROR, REQUEST_DEPARTMENT_LIST_SUCCESS, REQUEST_HOSPITAL_LIST, REQUEST_HOSPITAL_LIST_ERROR, REQUEST_HOSPITAL_LIST_SUCCESS, REQUEST_LOCATION_LIST, REQUEST_LOCATION_LIST_ERROR, REQUEST_LOCATION_LIST_SUCCESS, REQUEST_PROMOTION_LIST, REQUEST_PROMOTION_LIST_ERROR, REQUEST_PROMOTION_LIST_SUCCESS } from './Constant';

// userReducer.js
const initialState = {
    user: null,
    loading: false,
    error: null,
};
  
export const homeReducer = (state = initialState, action) => {
    switch (action.type) {
    case REQUEST_DEPARTMENT_LIST:
        return { ...state, loading: true };
    case REQUEST_DEPARTMENT_LIST_SUCCESS:
        return { ...state, loading: false, department: action.payload };
    case REQUEST_DEPARTMENT_LIST_ERROR:
        return { ...state, loading: false, error: action.payload };
    case REQUEST_LOCATION_LIST:
        return { ...state, loading: true };
    case REQUEST_LOCATION_LIST_SUCCESS:
        return { ...state, loading: false, location: action.payload };
    case REQUEST_LOCATION_LIST_ERROR:
        return { ...state, loading: false, error: action.payload };
    case REQUEST_HOSPITAL_LIST:
        return { ...state, loading: true };
    case REQUEST_HOSPITAL_LIST_SUCCESS:
        return { ...state, loading: false, hospital: action.payload };
    case REQUEST_HOSPITAL_LIST_ERROR:
        return { ...state, loading: false, error: action.payload };
    case REQUEST_PROMOTION_LIST:
        return { ...state, loading: true };
    case REQUEST_PROMOTION_LIST_SUCCESS:
        return { ...state, loading: false, promotions: action.payload };
    case REQUEST_PROMOTION_LIST_ERROR:
        return { ...state, loading: false, error: action.payload };
    default:
        return state;
    }
};
  